<template lang="pug">
    v-flex(shrink)
        v-layout(align="center" class="m-block-object-actions")
            m-block-action-primary(:item="primaryAction")
            m-block-actions(:items="actions" v-bind="$attrs" v-on="$listeners")
</template>
<script>
import baseActions from "@mixins/components/modules/blocks/actions/base";
import MBlockActionPrimary from "@modules/blocks/actions/m-block-action-primary";
import MBlockActions from "@modules/blocks/actions/m-block-actions";
export default {
    name: 'm-block-effectiveness-actions',
    components: { MBlockActions, MBlockActionPrimary },
    mixin: [baseActions],
    props: {
        assessmentId: {
            type: String,
        }
    },
    computed: {
        primaryAction(){
            let firstActiveAction = this.actions.filter(a => a.hidden == false)[0];
            return firstActiveAction;
        },
        actions() {
            return [
                {
                    icon: 'search',
                    text: this.$t('modules.blocks.m-block-effectiveness-actions.actions.detail.text'),
                    func: this.zoom,
                    hidden: false,
                    group: 'action'
                }
            ]
        }
    },
    methods: {
        zoom() {
            //TODO handle empty riskAssessmentId value
            this.$router.push({
                name: this.nav.dashboard.service.effectiveness_control.view.name,
                params: {
                    key: this.$attrs.item.key
                },
                query: {
                    riskAssessmentId: this.assessmentId
                }
            })
        }
    }
}
</script>
